/* Gumdrop Custom Theme - gd-custom.js */
(function () {
  'use strict';

  function initFaq() {
    document.querySelectorAll('.gd-faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var isOpen = this.classList.contains('gd-open');
        document.querySelectorAll('.gd-faq-item').forEach(function (f) { f.classList.remove('gd-open'); });
        if (!isOpen) this.classList.add('gd-open');
      });
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.gd-reveal').forEach(function (el) { el.classList.add('gd-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('gd-visible'); }, i * 70);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.gd-reveal').forEach(function (el) { observer.observe(el); });
  }

  function initAddToCart() {
    document.querySelectorAll('.gd-add-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = this.dataset.variantId;
        if (!variantId) return;
        var self = this;
        self.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            self.textContent = '✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () { self.textContent = '+'; }, 1800);
          })
          .catch(function () { self.textContent = '+'; });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFaq();
    initReveal();
    initAddToCart();
  });
})();
